"use client"
import { Badge, MenuItem, Text } from "@mantine/core"

import { Tooltip } from "@/components/generic/Tooltip"
import { clampString, needStringToBeClamped } from "@/lib/stringUtils"
import { useSyncStore } from "@/app/(store)/sync.store"

const MAX_COMPANY_NAME_CHARACTERS_BEFORE_CLAMPING = 22

const BASE_TEST_ID = "menu-item-user-data-"

export function MenuItemUserData() {
  const { userStatus: user } = useSyncStore()

  const userCompanyName = user?.companyName ?? ""

  const isCompanyNameClamped = needStringToBeClamped({
    value: userCompanyName,
    maxLength: MAX_COMPANY_NAME_CHARACTERS_BEFORE_CLAMPING,
  })
  return (
    <MenuItem
      component="div"
      className="cursor-default"
      classNames={{
        itemLabel: "w-full flex flex-col gap-1.5",
      }}
      data-testid={`${BASE_TEST_ID}container`}
    >
      {isCompanyNameClamped ? (
        <Tooltip label={userCompanyName} position="left">
          <Text
            size="sm"
            lineClamp={1}
            truncate="end"
            data-testid={`${BASE_TEST_ID}company-name-tooltip`}
          >
            {clampString({
              value: userCompanyName,
              maxLength: MAX_COMPANY_NAME_CHARACTERS_BEFORE_CLAMPING,
            })}
          </Text>
        </Tooltip>
      ) : (
        <Text
          size="sm"
          lineClamp={1}
          truncate="end"
          data-testid={`${BASE_TEST_ID}company-name`}
        >
          {userCompanyName}
        </Text>
      )}
      <div className="flex flex-row items-center justify-between">
        <Text size="xs" c="dimmed" data-testid={`${BASE_TEST_ID}user-id`}>
          ID: {user?.accountId}
        </Text>
        <Badge
          color={
            user?.isAdmin ? "grape" : user?.isOwner ? "red" : "rBackBlue.9"
          }
          size="xs"
          className="text-xs"
          classNames={{
            label: "!capitalize !text-[0.6rem]",
          }}
          data-testid={`${BASE_TEST_ID}user-role`}
        >
          {user?.isAdmin ? "Admin" : user?.isOwner ? "Owner" : "User"}
        </Badge>
      </div>
    </MenuItem>
  )
}
